var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_c('div',{ref:"imgViewerBox",staticClass:"viewer_box"},[_c('v-row',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.imgResize),expression:"imgResize"}]},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":"","alt":""}})])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36f48b22","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cowork/general/file/viewer/detail/ViewerImage.vue
// module id = null
// module chunks = 